import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { firebaseConfig, storage, db, auth } from './firebase'
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { getFirestore, doc, getDoc, updateDoc } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import firebase from "firebase/compat/app";
import "firebase/storage";
import "firebase/firestore";
import "firebase/auth";

firebase.initializeApp(firebaseConfig);

const ProfileComponent = ({  }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [user, setUser] = useState(null);
  const [image, setImage] = useState(null);
  const [uploading, setUploading] = useState(false);

  const currentUser = firebase.auth().currentUser; // Current logged-in user

  // Fetch user data from Firestore
  useEffect(() => {
    firebase
      .firestore()
      .collection("users")
      .doc(currentUser.uid)
      .get()
      .then((snapshot) => {
        if (snapshot.exists) {
          setUser(snapshot.data());
        } else {
          console.log("User does not exist");
        }
      });
  }, []);

  // Handle file selection
  const handleFileChange = (e) => {
    if (e.target.files[0]) {
      setImage(e.target.files[0]);
    }
  };

  // Upload image to Firebase Storage
  const handleUpload = async () => {
    if (!image) {
      alert("Please select an image first.");
      return;
    }

    setUploading(true);

    try {
      // Reference to the image in Firebase Storage
      const imageRef = ref(storage, `profilePictures/${currentUser.uid}/${image.name}`);

      // Upload the image
      await uploadBytes(imageRef, image);

      // Get the download URL
      const downloadURL = await getDownloadURL(imageRef);

      // Update the Firestore document with the image URL
      const userDocRef = doc(db, "users", currentUser.uid);
      await updateDoc(userDocRef, { ppUri: downloadURL });

      // Update local state
      setUser((prev) => ({ ...prev, ppUri: downloadURL }));
      alert("Profile picture updated successfully!");
    } catch (error) {
      console.error("Error uploading image:", error);
      alert("Failed to upload image. Please try again.");
    } finally {
      setUploading(false);
    }
  };


  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const styles = {
    profile: {
      display: "flex",
      alignItems: "center",
      cursor: "pointer", // Makes the div clickable
      border: "1px solid #ccc",
      padding: "10px",
      borderRadius: "10px",
      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
      backgroundColor: "#f9f9f9",
    },
    profileAvatar: {
      width: "50px",
      height: "50px",
      borderRadius: "50%",
    },
    profileName: {
      fontSize: "16px",
      fontWeight: "bold",
      margin: 0,
    },
    profileHandle: {
      fontSize: "14px",
      color: "gray",
      margin: 0,
    },
    modalContent: {
      padding: "20px",
      borderRadius: "10px",
      backgroundColor: "white",
      maxWidth: "400px",
      margin: "0 auto",
      textAlign: "center",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    },
    modalOverlay: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
    },
    closeButton: {
      marginTop: "10px",
      padding: "10px 20px",
      border: "2px solid #007bff",
      borderRadius: "5px",
      backgroundColor: "white",
      color: "#007bff",
      cursor: "pointer",
      fontSize: "14px",
    },
    closeButton2: {
      marginTop: "10px",
      padding: "10px 20px",
      border: "2px",
      borderRadius: "5px",
      backgroundColor: "#007bff",
      color: "white",
      cursor: "pointer",
      fontSize: "14px",
    },
    profile2: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: '#000222',
        padding: '10px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      },
      profileAvatar2: {
        width: '52px',
        height: '52px',
        borderRadius: '50%',
        marginRight: '21px',
      },
      profileName2: {
        fontSize: '17px',
        fontWeight: 'bold',
        color: 'white',
        margin: 0,
      },
      profileHandle2: {
        fontSize: '11px',
        color: 'white',
        margin: 0,
      },
      fileInputContainer: {
        display: "flex", // Enable flexbox
        justifyContent: "center", // Center horizontally
        alignItems: "center", // Center vertically
        height: "100%", // Ensure the container takes full height of the modal
      },
      fileInput: {
        cursor: "pointer", // Optional: Make the file input look interactive
      },
  };

  if (!user) {
    return <div></div>
  } else
  return (
    <>
      {/* Clickable Profile Div */}
      <div style={styles.profile2} onClick={openModal}>
        
          { user.ppUri ?
        <img
        src={user.ppUri }
        alt="Profile"
        style={styles.profileAvatar2}
        />
        
        
        :<img
        src={"https://t3.ftcdn.net/jpg/01/65/63/94/360_F_165639425_kRh61s497pV7IOPAjwjme1btB8ICkV0L.jpg"}
        alt="Profile"
        style={styles.profileAvatar2}

      />
        
        
        
        }

        <div>
          <p style={styles.profileName2}>{user.name}</p>
          <p style={styles.profileHandle2}>{user.email}</p>
        </div>
      </div>

      {/* Modal */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        style={{
          overlay: styles.modalOverlay,
          content: { inset: "auto", border: "none", padding: 0 },
        }}
        ariaHideApp={false}
      >
<div style={{ ...styles.modalContent, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
<img
            src="https://i.ibb.co/s2dBvDt/elevate.png"
            alt="logo"
            className=" -p-4 "
            width={300}
          ></img>
          { user.ppUri ?
        <img
        src={user.ppUri }
        alt=""
        style={{ width: "150px", height: "150px", borderRadius: "50%" }}
      />
        
        
        :<img
        src={"https://t3.ftcdn.net/jpg/01/65/63/94/360_F_165639425_kRh61s497pV7IOPAjwjme1btB8ICkV0L.jpg"}
        alt=""
        style={{ width: "150px", height: "150px", borderRadius: "50%" }}
      />
        
        
        
        }

          <div>
        
      </div>
          <h2 style={styles.profileName}>{user.name}</h2>
          <p style={styles.profileHandle}>{user.email}</p>
          <br/>

          <div style={styles.fileInputContainer}>
    <input type="file" accept="image/*" onChange={handleFileChange} style={{marginLeft:140}} />
  </div>        <button onClick={handleUpload} disabled={uploading} style={styles.closeButton}>
          {uploading ? "Uploading..." : "Upload Profile Picture"}
        </button>
          <button style={styles.closeButton2} onClick={closeModal}>
            Close
          </button>
        </div>
      </Modal>
    </>
  );
};

export default ProfileComponent;
